<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="os-tabs-w" v-if="current.id">
              <div class="os-tabs-controls os-tabs-complex text-right">
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <span aria-expanded="true" class="nav-link active" style="font-size: 15px;">
                      Total Devolución: Q {{ totalDevolucion }}
                    </span>
                  </li>
                </ul>
              </div>
              <div class="row col-12">
                <div class="col-11">
                  <router-link class="btn btn-outline-blue" :to="{ name: 'inventario-devoluciones_proveedor' }">
                    <i class="fa fa-arrow-left"></i>
                    Regresar a Devoluciones
                  </router-link>
                </div>
                <div class="col-1">
                  <div class="btn-group">
                    <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                      data-toggle="dropdown" type="button">
                      <i class="fa fa-cogs"></i>
                      Acciones
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button class="dropdown-item" disabled @click="abrir" href="#">
                        <i class="fas fa-edit"></i>
                        Abrir Devolución
                      </button>
                      <button class="dropdown-item" @click="cerrar" :disabled="!(current.estado == 'A')" href="#">
                        <i class="fas fa-check-circle"></i>
                        Finalizar Transacción
                      </button>
                      <button class="dropdown-item" @click="anular" :disabled="!(current.estado != '9')" href="#">
                        <i class="fas fa-minus-square"></i>
                        Dar de Baja
                      </button>
                      <div class="dropdown-divider"></div>
                    </div>
                  </div>
                </div>
              </div>
              <br>
            </div>
            <div class="element-box">
              <form @submit="guardar">
                <h5 class="form-header" style="text-align:center;">
                  Devolución a Proveedor #{{ current.numero }}
                  <br>
                  <div class="badge col-2" :class="{
                    'badge-success': current.estado == 'A',
                    'badge-warning': current.estado == 'B',
                    'badge-danger': current.estado == '9',
                  }" style="text-align: center;">
                    <i class="os-icon os-icon-ui-09"></i>
                    <span v-if="current.estado_str">{{ current.estado_str }}</span>
                    <span v-if="!current.estado_str">En Proceso</span>
                  </div>
                </h5>
                <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{
                  current.errors.detail }}</small>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label v-bind:class="{
                        'text-danger':
                          current.errors.tienda && current.errors.tienda.length > 0,
                      }">Tienda</label>
                      <select class="form-control" autofocus="autofocus" v-model="current.tienda"
                        :disabled="current.estado != 'A'">
                        <option v-for="(tienda, key) in tiendas" :value="tienda.codigo" :key="key">
                          {{ tienda.nombre }}
                        </option>
                      </select>
                      <small v-if="current.errors && current.errors.tienda" class="form-text text-danger">{{
                        current.errors.tienda[0] }}</small>
                    </div>
                  </div>
                  <div class="col col-sm-5">
                    <ProveedoresSelectComponent :current="current" :disabled="current.estado != 'A'" />
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Referencia</label>
                      <input v-model="current.referencia" autofocus="autofocus" class="form-control"
                        placeholder="Referencia" type="text" :disabled="current.estado != 'A'" />
                      <small v-if="current.errors && current.errors.motivo_ajuste" class="form-text text-danger">{{
                        current.errors.motivo_ajuste[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label v-bind:class="{
                        'text-danger':
                          current.errors.fecha && current.errors.fecha.length > 0,
                      }">Fecha</label>
                      <input v-model="current.fecha" class="form-control" placeholder="Fecha" :disabled="true"
                        type="text" />
                      <small v-if="current.errors && current.errors.fecha" class="form-text text-danger">{{
                        current.errors.fecha[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Usuario</label>
                      <input :disabled="true" class="form-control" v-model="current.usuario" type="text" />
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label v-bind:class="{
                        'text-danger': current.errors && current.errors.observacion,
                      }">Motivo de Devolución</label>
                      <input v-model="current.observacion" autofocus="autofocus" class="form-control"
                        placeholder="Motivo de Devolución" type="text" :disabled="current.estado != 'A'" />
                      <small v-if="current.errors && current.errors.observacion" class="form-text text-danger">{{
                        current.errors.observacion[0] }}</small>
                    </div>
                  </div>
                </div>
                <div class="table-responsive" v-if="current.id != null">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Producto</th>
                        <th>Posición</th>
                        <th>unidad medida</th>
                        <th class="text-center">cantidad um</th>
                        <th class="text-center" v-if="current.observacion != 'DEVOLUCION DESDE RECEPCION'">
                          Precio
                        </th>
                        <th class="text-center" v-if="current.observacion == 'DEVOLUCION DESDE RECEPCION'">
                          Total
                        </th>
                        <th class="text-center" v-if="current.observacion != 'DEVOLUCION DESDE RECEPCION'">
                          Total
                        </th>
                        <th class="text-center" v-if="current.estado == 'A'">Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="detalle in current.devolucionproveedord_set" v-bind:key="detalle.id">
                        <td>{{ detalle.producto.sku }}</td>
                        <td>{{ detalle.producto.nombre }}</td>
                        <td>
                          {{ detalle.posicion.id }}
                          {{ detalle.posicion.descripcion }}
                        </td>
                        <td>{{ detalle.unidad_medida.nombre }}</td>
                        <td class="text-right bolder nowrap" style="font-weight: 500">
                          <span> {{ detalle.cantidad_um }}</span>
                        </td>
                        <td class="text-right">Q {{ detalle.costo }}</td>
                        <td class="text-right" v-if="current.observacion != 'DEVOLUCION DESDE RECEPCION'">
                          Q {{ detalle.valor_total }}
                        </td>
                        <td class="text-center" style="width: 200px" v-if="current.estado == 'A'">
                          <button class="btn btn-sm btn-danger mr-1" type="button" v-if="current.estado == 'A'"
                            @click="eliminarDetalle(detalle)">
                            <i class="fa fa-trash"></i>
                            Eliminar
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-------------------- END - Basic Table -------------------->
                </div>
                <br>
                <div style="float: right;">
                  <button type="button" class="btn btn-sm btn-secondary" @click="showModalAddDetail"
                    v-if="current.estado == 'A'">
                    <i class="fa fa-plus"></i>
                    Agregar Producto
                  </button>
                </div>
                <br>
                <div class="form-buttons-w">
                  <button class="btn btn-md btn-success" v-if="current.estado == 'A'" type="submit">
                    Guardar Cambios &nbsp;<i class="fas fa-check"></i>
                  </button>
                  <button :disabled="current.estado == 'A'" class="btn btn-outline-dark" @click="imprimir">
                    Imprimir Devolución &nbsp;
                    <i class="fa fa-print"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="modalAddDetailReqTraslado" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12 mb-1">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        currentDetalle.errors.producto &&
                        currentDetalle.errors.producto.length > 0,
                    }">Producto</label>
                    <v-select label="nombre" v-model="currentDetalle.producto" :filterable="false" :options="productos"
                      @search="onSearchProducto" @input="setSelected">
                      <template slot="no-options">Producto...</template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          <img :src="option.image" />
                          {{ option.sku }} - {{ option.nombre }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          <img :src="option.image" />
                          {{ option.sku }} - {{ option.nombre }}
                        </div>
                      </template>
                    </v-select>
                    <small v-if="currentDetalle.errors && currentDetalle.errors.producto"
                      class="form-text text-danger">{{
                        currentDetalle.errors.producto[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-12 mb-1">
                  Lotes:
                  <select v-model="currentDetalle.codigo_lote" v-if="
                    currentDetalle.productolote_set != null &&
                    currentDetalle.productolote_set.length > 0
                  " class="form-control" autofocus="autofocus">
                    <option v-for="detalle in currentDetalle.productolote_set" :value="detalle.id"
                      v-bind:key="detalle.id">
                      Lote: {{ detalle.codigo_lote }} || Vence:
                      {{ detalle.fecha_vence }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-12">
                  Posicion:
                  <select v-model="currentDetalle.posicion" class="form-control">
                    <option v-for="detalle in posiciones" :value="detalle.posicion_id" v-bind:key="detalle.id">
                      {{ detalle.codigo_barra }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.unidad_medida &&
                        current.errors.unidad_medida.length > 0,
                    }">Unidad de Medida</label>
                    <select v-if="
                      currentDetalle.productounidadmedida_set != null &&
                      currentDetalle.productounidadmedida_set.length > 0
                    " class="form-control" v-model="currentDetalle.unidad_medida">
                      <option v-for="(
                          unidad_medida, key
                        ) in currentDetalle.productounidadmedida_set" :value="unidad_medida.unidad_medida.id"
                        :key="key">
                        {{ unidad_medida.unidad_medida.nombre }}
                      </option>
                    </select>
                    <small v-if="current.errors && current.errors.unidad_medida" class="form-text text-danger">{{
                      current.errors.unidad_medida[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        currentDetalle.errors.cantidad_um &&
                        currentDetalle.errors.cantidad_um.length > 0,
                    }">Cantidad</label>
                    <input v-model="currentDetalle.cantidad_um" class="form-control" placeholder="Cantidad" type="text"
                      style="text-align: center; font-size: 200%" v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad_um &&
                          currentDetalle.errors.cantidad_um.length > 0,
                      }" />
                    <small v-if="currentDetalle.errors && currentDetalle.errors.cantidad_um"
                      class="form-text text-danger">{{
                        currentDetalle.errors.cantidad_um }}</small>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        currentDetalle.errors.valor &&
                        currentDetalle.errors.valor.length > 0,
                    }">Precio</label>
                    <input v-model="currentDetalle.valor" class="form-control" placeholder="Precio" type="text"
                      style="text-align: center; font-size: 200%" v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.valor &&
                          currentDetalle.errors.valor.length > 0,
                      }" />
                    <small v-if="currentDetalle.errors && currentDetalle.errors.valor" class="form-text text-danger">{{
                      currentDetalle.errors.valor }}</small>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregaDetalle" type="button">
              Agregar
            </button>
            <button class="btn btn-secondary" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import PosicionesService from "@/services/inventario/PosicionesService";
import DynamicService from "@/services/commons/DynamicService";
import DevolucionesProveedoresService from "@/services/inventario/DevolucionesProveedoresService";
import Notifications from "@/notifications/notifications";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";

export default {
  components: {
    ProveedoresSelectComponent,
    UnidadMedidaSelectComponent,
  },
  data() {
    return {
      current: {
        id: null,
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        motivo_ajuste: "",
        errors: [],
        ajusteinventariod_set: [],
      },

      productos: [],
      posiciones: [],
      options: [],
      producto_lote: [],

      bodegas: [],
      secciones: [],
      racks: [],
      niveles: [],

      busqueda_posicion: {
        bodega_id: null,
        seccion_id: null,
        rack_id: null,
        posicion_id: null,
      },
      currentDetalle: {
        cantidad: 0,
        posicion: 0,
        producto: "",
        codigo_lote: 0,
        productolote_set: [],
        errors: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
    fecha_str: function () {
      let self = this;
      return self.customFormatter(self.current.fecha);
    },
    totalDevolucion() {
      if (this.current.devolucionproveedord_set) {
        return this.current.devolucionproveedord_set.reduce((total, detalle) => {
          return total + (parseFloat(detalle.valor_total) || 0);
        }, 0).toFixed(2);
      }
      return 0;
    },
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    formatoFecha() {
      let self = this;
      self.current.fecha = self.current.fecha.replace(/\//g, "-");
    },
    totalDevolucion() {
      const detalles = this.current.devolucionproveedord_set || [];
      return detalles.reduce((sum, detalle) => {
        if (this.current.observacion === 'DEVOLUCION DESDE RECEPCION') {
          return sum + parseFloat(detalle.valor_total || 0);
        } else {
          return sum + parseFloat(detalle.valor_total || 0);
        }
      }, 0).toFixed(2);
    },
    setSelected(value) {
      let self = this;
      ProductosService.getById(value.sku).then((res) => {
        self.currentDetalle.productolote_set = res.data.productolote_set;
        self.currentDetalle.productounidadmedida_set = res.data.productounidadmedida_set;
        self.currentDetalle.codigo_lote = res.data.productolote_set[0].id;
      });
    },
    refreshCurrent() {
      let self = this;
      DevolucionesProveedoresService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.usuario = response.data.usuario.name;
        self.current.tienda = response.data.tienda;
        self.current.fecha = self.customFormatter(self.current.fecha);
        self.current.errors = [];
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = 0;
        console.log(self.current);
      });
    },
    refreshBodegas() {
      let self = this;
      DynamicService.fetch("cat", "tienda-bodega", {
        tienda: self.current.tienda,
        quitar_paginacion: true,
      }).then((res) => {
        self.bodegas = res.data;
      });
    },
    changeBodega() {
      this.refreshSecciones();
    },
    changeSeccion() {
      this.refreshRacks();
    },
    changeRack() {
      this.refreshNiveles();
    },
    changeNivel() {
      this.refreshPosiciones();
    },
    refreshSecciones() {
      let self = this;
      DynamicService.fetch("cat", "tienda-seccion", {
        tienda: self.current.tienda,
        bodega: self.busqueda_posicion.bodega_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.secciones = res.data;
      });
    },
    refreshPosiciones() {
      let self = this;
      let params = {
        page: 1,
        tienda: self.current.tienda,
        quitar_paginacion: true,
      };
      if (self.busqueda_posicion.bodega_id) {
        params.bodega_id = self.busqueda_posicion.bodega_id;
      }
      if (self.busqueda_posicion.seccion_id) {
        params.seccion_id = self.busqueda_posicion.seccion_id;
      }
      if (self.busqueda_posicion.rack_id) {
        params.rack_id = self.busqueda_posicion.rack_id;
      }
      if (self.busqueda_posicion.nivel_id) {
        params.nivel_id = self.busqueda_posicion.nivel_id;
      }

      console.log(params);

      PosicionesService.fetch(params).then((res) => {
        self.posiciones = res.data;
      });
    },
    refreshSecciones() {
      let self = this;
      DynamicService.fetch("cat", "tienda-seccion", {
        tienda: self.current.tienda,
        bodega: self.busqueda_posicion.bodega_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.secciones = res.data;
      });
    },
    refreshRacks() {
      let self = this;
      DynamicService.fetch("cat", "tienda-rack", {
        tienda: self.current.tienda,
        seccion: self.busqueda_posicion.seccion_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.racks = res.data;
      });
    },
    refreshNiveles() {
      let self = this;
      DynamicService.fetch("cat", "tienda-nivel", {
        tienda: self.current.tienda,
        rack: self.busqueda_posicion.rack_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.niveles = res.data;
      });
    },

    guardar(e) {
      e.preventDefault();
      let self = this;
      let current = Object.assign({}, self.current);
      current.tienda = self.current.tienda;
      if (self.current.proveedor) {
        current.proveedor = self.current.proveedor.codigo;
      }
      DevolucionesProveedoresService.save(current)
        .then((response) => {
          if (current.id == null) {
            self.$router.push({
              name: "inventario-devoluciones_proveedor-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },
    onSearchPosicion(search, loading) {
      loading(true);
      this.searchPosicion(loading, search, this);
    },

    searchPosicion: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);

        return;
      }
      let self = this;
      let params = {
        page: 1,
        tienda: vm.current.tienda,
        quitar_paginacion: true,
        "filter[search]": search,
      };
      if (self.busqueda_posicion.bodega_id) {
        params.bodega_id = self.busqueda_posicion.bodega_id;
      }
      if (self.busqueda_posicion.seccion_id) {
        params.seccion_id = self.busqueda_posicion.seccion_id;
      }
      if (self.busqueda_posicion.rack_id) {
        params.rack_id = self.busqueda_posicion.rack_id;
      }
      if (self.busqueda_posicion.nivel_id) {
        params.nivel_id = self.busqueda_posicion.nivel_id;
      }

      PosicionesService.fetch(params).then((res) => {
        vm.posiciones = res.data;
        loading(false);
      });
    }, 350),

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },

    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),

    customFormatter(date) {
      var d = date.toString().split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];

      return moment(str_d).format("DD/MM/YYYY");
    },
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
      });
      PosicionesService.fetch({
        page: 1,
        tienda: self.current.tienda,
        activo: true,
      }).then((res) => {
        self.posiciones = res.data.results;
      });
      $("#modalAddDetailReqTraslado").modal();
    },

    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      if (det.codigo_lote) {
        det.producto_lote = det.codigo_lote;
      }
      console.log(det.unidad_medida);
      console.log(det);
      DevolucionesProveedoresService.agregar_detalle(self.current.id, det)
        .then((response) => {
          Notifications.alert.success(
            "¡Listo!",
            "Se añadió la línea al detalle."
          );
          self.refreshCurrent();
          self.refreshDetalleDefault();
          self.$refs.cerrarModal.click();
        })
        .catch((error) => {
          console.log(error.response.data);
          self.currentDetalle.errors = error.response.data;
        });
    },

    eliminarDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar Detalle",
        "¿Estás seguro que deseas eliminar la línea?",
        "Si, Eliminar",
        function () {
          DevolucionesProveedoresService.eliminar_detalle(self.current.id, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "¡Listo!",
                "Se eliminó la línea."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Devolución de Proveedor",
        "Desea Abrir la transacción?",
        "Si, Abrir",
        function () {
          DevolucionesProveedoresService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Devolución de proveedor",
                "Se abrió el documento actual, puedes continuar."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Finalizar Devolución",
        "¿Deseas cerrar la transacción actual?",
        "Si, Finalizar",
        function () {
          DevolucionesProveedoresService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Devolución Finalizada",
                "Se ha cerrado la transacción."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Cerrar Transaccion", error.response.data.detail);
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Anular la Devolución",
        "¿Deseas dar de baja a la transacción?",
        "Si, Anular",
        function () {
          DevolucionesProveedoresService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Devolución Anulada",
                "Se anuló la transacción."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Anular Transaccion", error.response.data.detail);
            });
        }
      );
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        cantidad: 0,
        cantidad_um: 0,
        unidad_medida: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      };
    },
    imprimir() {
      let self = this;
      DevolucionesProveedoresService.pdf(self.current.id)
        .then((response) => {
          console.log(response.data.output);
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
  },
};
</script>
